<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud :ref="'documentosCrud'" crudName="Documentos" newText="Enviar documento" :table="table"
          :columns="columns" :options="options" :endPoint="endPoint" :enableAdd="true" :enableEdit="false"
          :enableDelete="true" :enableView="true" :enableReset="false" :dataForm="dataForm">
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import { STATUS_DOCUMENTO, formatarData } from "../../utils/assinatura";

export default {
  data: function () {
    return {
      table: "documentosTable",
      columns: ["id", "nome", "status", "created_at", "actions"],
      tableData: ["id", "nome", "status", "created_at"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["nome", "status"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          nome: "Documento",
          status: "Status",
          created_at: "Enviado em",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: Object.keys(STATUS_DOCUMENTO).map((id) => ({ id, text: STATUS_DOCUMENTO[id].texto })),
        },
        templates: {
          status: function (h, row) {
            const status = STATUS_DOCUMENTO[row.status] || { texto: row.status, cor: "secondary" };
            return h("span", { class: "badge badge-light-" + status.cor }, status.texto);
          },
          created_at: function (h, row) {
            return formatarData(row.created_at);
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "documentos/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        nome: "nome",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>
